import React, { useEffect, useState } from 'react';
import { listRestaurants } from '../../services/restaurantService';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import { FaSpinner, FaPlus, FaUtensils, FaArrowLeft } from 'react-icons/fa';
import { motion } from 'framer-motion';

function OwnerDashboard() {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRestaurants = async () => {
      const token = localStorage.getItem('ownerToken');
      if (token) {
        try {
          const data = await listRestaurants(token);
          setRestaurants(data);
          setLoading(false);
        } catch (err) {
          setError('Failed to fetch restaurants. Please try again.');
          setLoading(false);
        }
      } else {
        setError('Authentication token not found.');
        setLoading(false);
      }
    };

    fetchRestaurants();
  }, []);

  const truncateDescription = (description, maxLength = 100) => {
    if (description.length <= maxLength) return description;
    return `${description.substring(0, maxLength).trim()}...`;
  };

  const getRandomColor = () => {
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  if (loading) {
    return (
      <div className='flex justify-center items-center h-screen'>
        <FaSpinner className='animate-spin text-4xl text-blue-500' />
      </div>
    );
  }

  if (error) {
    return <div className='text-red-500 text-center'>{error}</div>;
  }

  return (
    <div className='container mx-auto px-4 py-8'>
      <div className='flex justify-between items-center mb-6'>
        <h1 className='text-3xl font-bold'>Owner Dashboard</h1>
        <button
          onClick={() => navigate('/restaurants/new')}
          className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center'
        >
          <FaPlus className='mr-2' /> Create New Store
        </button>
      </div>

      {restaurants.length === 0 ? (
        <div className='text-center py-10'>
          <FaUtensils className='text-6xl text-gray-300 mx-auto mb-4' />
          <p className='text-xl text-gray-500'>
            You don't have any stores yet.
          </p>
          <p className='text-gray-400 mt-2'>
            Create a new store to get started!
          </p>
        </div>
      ) : (
        <motion.div
          className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {restaurants.map((restaurant) => (
            <motion.div
              key={restaurant._id}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
            >
              <Link to={`/restaurant/${restaurant._id}`} className='block'>
                <div className='bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300 relative'>
                  {restaurant.profileImage ? (
                    <img
                      src={restaurant.profileImage}
                      alt={restaurant.name}
                      className='w-full h-40 object-cover'
                    />
                  ) : (
                    <div
                      className='w-full h-40 flex items-center justify-center text-white text-3xl font-bold'
                      style={{ backgroundColor: getRandomColor() }}
                    >
                      {/* {restaurant.name.charAt(0).toUpperCase()} */}
                    </div>
                  )}
                  <div className='p-6'>
                    <h2 className='text-xl font-semibold mb-2'>
                      {restaurant.name}
                    </h2>
                    <p className='text-gray-600 mb-4'>
                      {truncateDescription(
                        restaurant.description || 'No description available.'
                      )}
                    </p>
                    <p className='text-gray-400 mb-4'>{restaurant.address}</p>
                    <span className='text-blue-500'>Manage Store</span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      )}
    </div>
  );
}

export default OwnerDashboard;

// import React, { useEffect, useState } from 'react';
// import {
//   createRestaurant,
//   listRestaurants,
// } from '../../services/restaurantService';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Link } from 'react-router-dom';

// function OwnerDashboard() {
//   const navigate = useNavigate();

//   const [showModal, setShowModal] = useState(false);
//   const [form, setForm] = useState({
//     name: '',
//     address: '',
//     description: '',
//     profileImage: null,
//   });

//   const [restaurants, setRestaurants] = useState([]);

//   // Fetch restaurants when component loads
//   useEffect(() => {
//     const token = localStorage.getItem('ownerToken');
//     if (token) {
//       listRestaurants(token).then((data) => {
//         setRestaurants(data);
//       });
//     } else {
//       toast.error('Failed to fetch restaurants.');
//     }
//   }, []);

//   const handleRestaurantClick = (id) => {
//     navigate(`/restaurant/${id}`);
//   };

//   // Custom file input handling
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setForm({ ...form, profileImage: file });
//   };

//   const handleDragOver = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     event.stopPropagation();

//     const file = event.dataTransfer.files[0];
//     setForm({ ...form, profileImage: file });
//   };

//   const handleFileUpload = async (file) => {
//     const formData = new FormData();
//     formData.append('profileImage', file);

//     try {
//       const response = await axios.post('/upload', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       return response.data.path; // Return the path where the file is stored
//     } catch (error) {
//       toast.error('Failed to upload image.');
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleSubmit = async () => {
//     const imagePath = await handleFileUpload(form.profileImage);
//     const response = await createRestaurant({
//       ...form,
//       profileImage: imagePath,
//     });

//     if (response.status === 201) {
//       toast.success('Restaurant created successfully!');
//       setRestaurants((prev) => [...prev, response.data]);
//     } else {
//       toast.error('Failed to create restaurant.');
//     }
//     setShowModal(false);
//   };

//   return (
//     <div className='p-6 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg shadow'>
//       {/* <h1 className='text-2xl font-bold mb-6'>Owner Dashboard</h1>

//       <button onClick={() => navigate(`/restaurants/new`)}>
//         Create New Restaurant
//       </button>

//       <div className='container mx-auto'>
//         <h2 className='text-2xl font-bold mb-6'>Your Restaurants</h2>
//         <button
//           className='bg-green-500 text-white py-2 px-4 rounded-lg mb-4'
//           onClick={() => setShowModal(true)}
//         >
//           Create Restaurant
//         </button>

//         <ul>
//           {restaurants.map((restaurant) => (
//             <li
//               key={restaurant._id}
//               className='mb-4 p-4 bg-white shadow rounded-lg'
//               onClick={() => handleRestaurantClick(restaurant._id)}
//             >
//               <h3 className='font-bold'>{restaurant.name}</h3>
//               <p>{restaurant.address}</p>
//               <a
//                 href={`/restaurant/${restaurant._id}`}
//                 className='text-blue-500'
//               >
//                 Manage Restaurant
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div> */}

//       <div className='container mx-auto px-4 py-8'>
//         <h1 className='text-3xl font-bold mb-6'>Owner Dashboard</h1>
//         <button
//           className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4'
//           onClick={() => navigate(`/restaurants/new`)}
//         >
//           Create New Restaurant
//         </button>
//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
//           {restaurants.map((restaurant) => (
//             <div
//               key={restaurant._id}
//               className='bg-white shadow-md rounded-lg p-6'
//             >
//               <h2 className='text-xl font-semibold mb-2'>{restaurant.name}</h2>
//               <p className='text-gray-600 mb-4'>{restaurant.address}</p>
//               <Link
//                 to={`/restaurant/${restaurant._id}`}
//                 className='text-blue-500 hover:text-blue-700'
//               >
//                 Manage Restaurant
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default OwnerDashboard;

// import React, { useEffect, useState } from 'react';
// import {
//   listRestaurants,
//   createRestaurant,
// } from '../../services/restaurantService';

// function OwnerDashboard() {
//   const [restaurants, setRestaurants] = useState([]);

//   useEffect(() => {
//     const token = localStorage.getItem('ownerToken');
//     if (token) {
//       listRestaurants(token).then((data) => {
//         setRestaurants(data);
//       });
//     }
//   }, []);

//   const handleAddRestaurant = async () => {
//     const token = localStorage.getItem('ownerToken');
//     if (token) {
//       const newRestaurant = await createRestaurant(
//         { name: 'New Restaurant' },
//         token
//       );
//       setRestaurants([...restaurants, newRestaurant]);
//     }
//   };

//   return (
//     <div>
//       <h1>Owner Dashboard</h1>
//       <button onClick={handleAddRestaurant}>Add Restaurant</button>
//       <ul>
//         {restaurants.map((restaurant) => (
//           <li key={restaurant._id}>{restaurant.name}</li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default OwnerDashboard;

// // OwnerDashboard.js = form for creating a new restaurant.

// function OwnerDashboard() {
//     const [form, setForm] = useState({ name: '', address: '', description: '', profileImage: null });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm(prevForm => ({ ...prevForm, [name]: value }));
//     };

//     const handleSubmit = async () => {
//         const token = localStorage.getItem('ownerToken');
//         const response = await createRestaurant(form, token);
//         if (response.status === 201) {
//             alert('Restaurant created successfully!');
//         } else {
//             alert('Failed to create restaurant.');
//         }
//     };

//     return (
//         <div>
//             <input name="name" value={form.name} onChange={handleChange} placeholder="Store Name" />
//             <input name="address" value={form.address} onChange={handleChange} placeholder="Address (Optional)" />
//             <input name="description" value={form.description} onChange={handleChange} placeholder="Description (Optional)" />
//             <input type="file" name="profileImage" onChange={e => setForm({ ...form, profileImage: e.target.files[0] })} />
//             <button onClick={handleSubmit}>Create Restaurant</button>
//         </div>
//     );
// }

// // import React, { useState } from 'react';
// import { DropzoneArea } from 'react-dropzone';
// import { createRestaurant } from '../../services/restaurantService';
// // import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import React, { useEffect, useState } from 'react';
// import { listRestaurants } from '../../services/restaurantService';

// import { useNavigate } from 'react-router-dom';

// // import React, { useState, useEffect } from 'react';
// import { getOwnerRestaurants } from '../../services/restaurantService';
// import RestaurantModal from '../restaurants/RestaurantModal';
// // import Toast from '../common/Toast';
// import { toast } from 'react-toastify';

// import axios from 'axios';

// import { getRestaurants } from '../../services/restaurantService';

// function OwnerDashboard() {
//   const navigate = useNavigate();

//   const [showModal, setShowModal] = useState(false);
//   const [form, setForm] = useState({
//     name: '',
//     address: '',
//     description: '',
//     profileImage: null,
//   });

//   //added this
//   const [restaurants, setRestaurants] = useState([]);

//   //   useEffect(() => {
//   //     const fetchRestaurants = async () => {
//   //       try {
//   //         const { data } = await getRestaurants();
//   //         setRestaurants(data);
//   //       } catch (error) {
//   //         showError('Failed to fetch restaurants.');
//   //       }
//   //     };

//   //     fetchRestaurants();
//   //   }, [showError]);
//   useEffect(() => {
//     const token = localStorage.getItem('ownerToken');
//     // const { data } = await axios.get('/api/restaurants', {
//     //     headers: { Authorization: `Bearer ${localStorage.getItem('ownerToken')}` },
//     //   });
//     if (token) {
//       listRestaurants(token).then((data) => {
//         setRestaurants(data);
//       });
//     } else {
//       toast.error('Failed to fetch restaurants.');
//     }
//   }, []);

//   const handleRestaurantClick = (id) => {
//     navigate(`/restaurant/${id}/actions`);
//   };

//   const handleFileUpload = async (file) => {
//     const formData = new FormData();
//     formData.append('profileImage', file);

//     try {
//       const response = await axios.post('/upload', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       return response.data.path; // This will be the path where the file is stored
//     } catch (error) {
//       toast.error('Failed to upload image.');
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleFileChange = (files) => {
//     setForm({ ...form, profileImage: files[0] });
//   };

//   const handleSubmit = async () => {
//     // added this:
//     const imagePath = await handleFileUpload(form.profileImage);
//     const response = await createRestaurant({
//       ...form,
//       profileImage: imagePath,
//     });

//     // ====================

//     // const response = await createRestaurant(form);
//     if (response.status === 201) {
//       toast.success('Restaurant created successfully!');
//       setRestaurants((prev) => [...prev, response]);
//     } else {
//       toast.error('Failed to create restaurant.');
//     }
//     setShowModal(false);
//   };

//   return (
//     <>
//       {/* <ToastContainer position='top-right' /> */}
//       <button onClick={() => setShowModal(true)}>Create New Restaurant</button>
//       {showModal && (
//         <div className='modal' onClick={() => setShowModal(false)}>
//           <div className='modal-content' onClick={(e) => e.stopPropagation()}>
//             <input
//               name='name'
//               value={form.name}
//               onChange={handleChange}
//               placeholder='Store Name'
//             />
//             <input
//               name='address'
//               value={form.address}
//               onChange={handleChange}
//               placeholder='Address (Optional)'
//             />
//             <input
//               name='description'
//               value={form.description}
//               onChange={handleChange}
//               placeholder='Description (Optional)'
//             />
//             <DropzoneArea onChange={handleFileChange} />
//             <button onClick={handleSubmit}>Create Restaurant</button>
//           </div>
//         </div>
//       )}
//       <div className='container mx-auto'>
//         <h2 className='text-2xl font-bold mb-6'>Your Restaurants</h2>
//         <button
//           className='bg-green-500 text-white py-2 px-4 rounded-lg mb-4'
//           onClick={() => setShowModal(true)}
//         >
//           Create Restaurant
//         </button>

//         <ul>
//           {restaurants.map((restaurant) => (
//             <li
//               key={restaurant._id}
//               className='mb-4 p-4 bg-white shadow rounded-lg'
//               onClick={() => handleRestaurantClick(restaurant._id)}
//             >
//               <h3 className='font-bold'>{restaurant.name}</h3>
//               <p>{restaurant.address}</p>
//               {/* Link to Restaurant Actions Page */}
//               <a
//                 href={`/restaurant/${restaurant._id}`}
//                 className='text-blue-500'
//               >
//                 Manage Restaurant
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div>
//       {/* <ul>
//         {restaurants.map((restaurant) => (
//           <li key={restaurant._id}>{restaurant.name}</li>
//         ))}
//       </ul> */}
//     </>
//   );
// }

// export default OwnerDashboard;

// // good css style?
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { getRestaurants, createRestaurant } from '../../services/restaurantService';
// import { toast } from 'react-toastify';

// function OwnerDashboard() {
//   const [restaurants, setRestaurants] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [newRestaurant, setNewRestaurant] = useState({
//     name: '',
//     address: '',
//     description: '',
//     profileImage: null,
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const { data } = await getRestaurants();
//         setRestaurants(data);
//       } catch (error) {
//         toast.error('Failed to fetch restaurants');
//       }
//     };
//     fetchRestaurants();
//   }, []);

//   const handleCreateRestaurant = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
//       formData.append('name', newRestaurant.name);
//       formData.append('address', newRestaurant.address);
//       formData.append('description', newRestaurant.description);
//       formData.append('profileImage', newRestaurant.profileImage);

//       await createRestaurant(formData);
//       toast.success('Restaurant created successfully');
//       setShowModal(false);
//       setNewRestaurant({ name: '', address: '', description: '', profileImage: null });
//     } catch (error) {
//       toast.error('Failed to create restaurant');
//     }
//   };

//   const handleImageChange = (e) => {
//     setNewRestaurant({ ...newRestaurant, profileImage: e.target.files[0] });
//   };

//   return (
//     <div className="max-w-7xl mx-auto mt-8">
//       <h2 className="text-2xl font-bold mb-4">Owner Dashboard</h2>
//       <button
//         onClick={() => setShowModal(true)}
//         className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//       >
//         Create New Restaurant
//       </button>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
//         {restaurants.map((restaurant) => (
//           <div
//             key={restaurant._id}
//             className="bg-white shadow-md rounded p-4 cursor-pointer"
//             onClick={() => navigate(`/restaurant/${restaurant._id}`)}
//           >
//             <h3 className="text-xl font-bold">{restaurant.name}</h3>
//             <p>{restaurant.description}</p>
//           </div>
//         ))}
//       </div>

//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-8 rounded shadow-lg">
//             <h3 className="text-xl font-bold mb-4">Create Restaurant</h3>
//             <form onSubmit={handleCreateRestaurant}>
//               <div className="mb-4">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Name</label>
//                 <input
//                   type="text"
//                   value={newRestaurant.name}
//                   onChange={(e) => setNewRestaurant({ ...newRestaurant, name: e.target.value })}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   required
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Address</label>
//                 <input
//                   type="text"
//                   value={newRestaurant.address}
//                   onChange={(e) => setNewRestaurant({ ...newRestaurant, address: e.target.value })}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Description</label>
//                 <textarea
//                   value={newRestaurant.description}
//                   onChange={(e) => setNewRestaurant({ ...newRestaurant, description: e.target.value })}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Profile Image</label>
//                 <input
//                   type="file"
//                   onChange={handleImageChange}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//               <div className="flex items-center justify-between">
//                 <button
//                   type="submit"
//                   className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//                 >
//                   Create
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => setShowModal(false)}
//                   className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default OwnerDashboard;

// // NO MODAL VERSION
// import React, { useEffect, useState } from 'react';
// import { fetchOwnerRestaurants } from '../../services/restaurantService';
// import { Link } from 'react-router-dom';

// function OwnerDashboard() {
//   const [restaurants, setRestaurants] = useState([]);

//   useEffect(() => {
//     const loadRestaurants = async () => {
//       const response = await fetchOwnerRestaurants();
//       setRestaurants(response.data);
//     };
//     loadRestaurants();
//   }, []);

//   return (
//     <div className="p-4">
//       <h1 className="text-2xl font-bold mb-4">Owner Dashboard</h1>
//       <Link
//         to="/restaurants/new"
//         className="bg-green-500 text-white px-4 py-2 rounded mb-4 inline-block"
//       >
//         Create New Restaurant
//       </Link>
//       <div className="space-y-4">
//         {restaurants.map((restaurant) => (
//           <div key={restaurant._id} className="border p-4 rounded-lg">
//             <h2 className="text-xl font-semibold">{restaurant.name}</h2>
//             <p>{restaurant.description}</p>
//             <Link
//               to={`/restaurants/${restaurant._id}`}
//               className="text-blue-500 hover:underline"
//             >
//               Manage Restaurant
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default OwnerDashboard;

// ==============

// // mistake here..?
// import React from 'react';
// import { Link } from 'react-router-dom';

// function OwnerDashboard({ match }) {
//     return (
//         <div className="flex h-screen bg-gray-100">
//             <aside className="w-64 bg-white p-5">
//                 <ul className="space-y-2">
//                     <li><Link to={`${match.url}/actions`} className="text-blue-500 hover:text-blue-600">Restaurant Actions</Link></li>
//                     <li><Link to={`${match.url}/subscribers`} className="text-blue-500 hover:text-blue-600">Subscribers</Link></li>
//                     <li><Link to={`${match.url}/text-messages`} className="text-blue-500 hover:text-blue-600">Text Messages</Link></li>
//                     <li><Link to={`${match.url}/qr-code`} className="text-blue-500 hover:text-blue-600">QR Code</Link></li>
//                 </ul>
//             </aside>
//             <div className="flex-1 p-10 text-2xl font-bold">
//                 Welcome to your Dashboard
//             </div>
//         </div>
//     );
// }

// import React, { useState, useEffect } from 'react';
// import { getOwnerRestaurants, createRestaurant } from '../../services/restaurantService';
// import RestaurantModal from '../restaurants/RestaurantModal';
// import Toast from '../common/Toast';

// function OwnerDashboard() {
//   const [restaurants, setRestaurants] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const response = await getOwnerRestaurants();
//         setRestaurants(response);
//       } catch (error) {
//         Toast.error('Failed to fetch restaurants.');
//       }
//     };
//     fetchRestaurants();
//   }, []);

//   const handleCreateRestaurant = async (restaurantData) => {
//     try {
//       const newRestaurant = await createRestaurant(restaurantData);
//       setRestaurants((prev) => [...prev, newRestaurant]);
//       setIsModalOpen(false);
//       Toast.success('Restaurant created successfully.');
//     } catch (error) {
//       Toast.error('Failed to create restaurant.');
//     }
//   };

//   return (
//     <div className="container mx-auto">
//       <h2 className="text-2xl font-bold mb-6">Your Restaurants</h2>
//       <button
//         className="bg-green-500 text-white py-2 px-4 rounded-lg mb-4"
//         onClick={() => setIsModalOpen(true)}
//       >
//         Create Restaurant
//       </button>

//       <ul>
//         {restaurants.map((restaurant) => (
//           <li key={restaurant._id} className="mb-4 p-4 bg-white shadow rounded-lg">
//             <h3 className="font-bold">{restaurant.name}</h3>
//             <p>{restaurant.address}</p>
//             {/* Link to Restaurant Actions Page */}
//             <a href={`/restaurant/${restaurant._id}`} className="text-blue-500">Manage Restaurant</a>
//           </li>
//         ))}
//       </ul>

//       {isModalOpen && (
//         <RestaurantModal
//           onClose={() => setIsModalOpen(false)}
//           onSubmit={handleCreateRestaurant}
//         />
//       )}
//     </div>
//   );
// }

// export default OwnerDashboard;
